export default __webpack_public_path__ + "static/media/CAC-badge.bfff044b.svg";